import { render, staticRenderFns } from "./TVDisplayPortrait.vue?vue&type=template&id=5e814214&scoped=true&"
import script from "./TVDisplayPortrait.vue?vue&type=script&lang=ts&"
export * from "./TVDisplayPortrait.vue?vue&type=script&lang=ts&"
import style0 from "./TVDisplayPortrait.vue?vue&type=style&index=0&id=5e814214&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e814214",
  null
  
)

export default component.exports